import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';

// Edit these three sizes freely — the amount stays optically centered either way.
const symbolSize = '38px';
const amountSize = '75px';
const currencySize = '26px';
const rows = [{
  label: '📘 The K-Smart Visual System™ (6 Volumes, 120+ pages)',
  price: '$19'
}, {
  label: '🎁 Bonus #1: +100 Visual Korean Flashcards™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #2: Hangul Express™ — Read Korean in 48h',
  price: 'FREE'
}, {
  label: '🎁 Bonus #3: K-Drama & K-Pop Phrases™ (50 expressions)',
  price: 'FREE'
}, {
  label: '🎁 Bonus #4: 30-Day Korean Challenge Calendar™',
  price: 'FREE'
}, {
  label: '🎁 Bonus #5: K-Smart Inner Circle (Private Discord)',
  price: 'FREE'
}, {
  label: '🛡️ 7-Day Money-Back Guarantee',
  price: 'INCLUDED'
}, {
  label: '♾️ Lifetime access & free updates',
  price: 'INCLUDED'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Delivery'
}, {
  icon: ShieldCheckIcon,
  label: '7-Day Guarantee'
}, {
  icon: CreditCardIcon,
  label: 'Debit / Credit'
}];
export function ValueStack() {
  return <section id="value" aria-label="Offer summary" className="border-y border-grape/10 bg-white/70" data-id="element-214" data-mp="2367ucyquzzwx">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" style={{
      paddingTop: "13px",
      paddingBottom: "25px"
    }} data-id="element-215" data-mp="1ydep89rhapkb">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-216" data-mp="2c49ulc2rqoj5">
          🚀 Start Speaking Korean In 30 Days
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-217" data-mp="2m40q9h32f9kt">
          Read Hangul, pronounce properly and build your first real Korean sentences. One single
          payment, lifetime access, everything ready to start today.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-218" data-mp="rqspl8ses3r9">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-219" data-mp="ms7v7pzu8eaq">
            <span data-id="element-220" data-mp="2rrz8ane401tr">What's included</span>
            <span data-id="element-221" data-mp="2rt1zyxj9a8aq">Price</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-222" data-mp="2vu3y1b1fseb4">
              <span className="text-plum/80" data-id="element-223" data-mp="30u02fbe1q7r7">{r.label}</span>
              <span className={r.price.startsWith('$') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} style={{
            fontSize: "15px"
          }} data-id="element-224" data-mp="35s1q69mf2v90">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-225" data-mp="3fhbhhn9fs9w2">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-226" data-mp="3jjy9ppa0rwts">
              Real total value: <span className="text-plum/40 line-through" data-id="element-227" data-mp="3ojkoi35hxl4p">USD 129</span>
            </span>
            <div className="flex justify-center" style={{
            paddingTop: "8px",
            paddingBottom: "11px"
          }} data-id="element-228" data-mp="3tgt5w1itll4w">
              <span className="text-grape-shine relative font-display font-black leading-none" style={{
              fontSize: amountSize,
              fontFamily: "Cinzel, serif"
            }} data-id="element-229" data-mp="7h6ovtnixv7w">
                <span className="absolute right-full top-1/2 -translate-y-1/2 pr-1 leading-none" style={{
                fontSize: "52px",
                color: "#C23C2D"
              }} data-id="element-230" data-mp="3tmlkh7sjb1rp">
                  $
                </span>
                19
                <span className="absolute left-full top-1/2 -translate-y-1/2 pl-2 leading-none" style={{
                fontSize: "26px",
                color: "#BB3529"
              }} data-id="element-231" data-mp="q5lh2k9kvfaa">
                  USD
                </span>
              </span>
            </div>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-232" data-mp="gf0l74lagov2">
              One-time payment
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-233" data-mp="18ww58tnx5dyh">
              Payment will be processed in your local currency.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-234" data-mp="144l79wcqo28k">
          <CTAButton data-id="element-235" data-mp="onmvcwe5hd35">Get The K-Smart Visual System</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-236" data-mp="to0utq1orepk">
          You save $110 USD (85% OFF) · One-time payment
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-237" data-mp="fpj91xvcccaa">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-238" data-mp="17g7916la3bmd">
              <Icon className="h-4 w-4 text-grape" data-id="element-239" data-mp="1ce8qjn3232vq" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}